class Observe {
  constructor() {
    this.fnsObj = {}
  }

  // 订阅方法
  on(key, fn) {
    if (!this.fnsObj[key]) {
      this.fnsObj[key] = [];
    }
    this.fnsObj[key].push(fn);
  }

  // 发布
  emmit(key, value) {
    if (this.fnsObj.hasOwnProperty(key) && this.fnsObj[key].length) {
      const fns = this.fnsObj[key];
      for (let i = 0; i < fns.length; i++) {
        fns[i].call(this, value);
      }
    }
  }

  //删除订阅者
  remove(key) {
    for (const k in this.fnsObj) {
      if (this.fnsObj.hasOwnProperty(k) && k === key) {
        delete this.fnsObj[k];
      }
    }
  }

  //删除所有订阅者
  removeAll() {
    this.fnsObj = {};
  }
}

const observeSession = new Observe();

export default observeSession;



// WEBPACK FOOTER //
// ./src/common/utils/observe.js